import { FC, useEffect } from 'react'

import ReactGA from 'react-ga'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { HAS_GOOGLE_ANALYTICS } from '../config/environments'

const GoogleAnalytics: FC<IProps> = ({ history, location }) => {
  useEffect(() => {
    function logPageView() {
      // Logging page view for each history change
      ReactGA.set({ page: location.pathname + location.search })
      ReactGA.pageview(location.pathname + location.search)
    }

    if (HAS_GOOGLE_ANALYTICS) {
      // add your UA code
      ReactGA.initialize('UA-118075260-5')

      // Necessary to log the initial page the user lands on
      ReactGA.pageview(location.pathname)

      const unListen = history.listen(logPageView)

      // Remove listener from history
      return () => {
        unListen()
      }
    }
  }, [history, location.pathname, location.search])

  return null
}

interface IProps extends RouteComponentProps<any> {}

export default withRouter(GoogleAnalytics)
